module.exports = {
        srcSet: __webpack_public_path__ + "static/media/rent_legal-800.cb9d2dcd.webp"+" 800w"+","+__webpack_public_path__ + "static/media/rent_legal-866.20b96641.webp"+" 866w",
        images: [{path: __webpack_public_path__ + "static/media/rent_legal-800.cb9d2dcd.webp",width: 800,height: 533},{path: __webpack_public_path__ + "static/media/rent_legal-866.20b96641.webp",width: 866,height: 577}],
        src: __webpack_public_path__ + "static/media/rent_legal-866.20b96641.webp",
        toString: function(){return __webpack_public_path__ + "static/media/rent_legal-866.20b96641.webp"},
        
        width: 866,
        height: 577
      }